import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { MediaApi } from 'api/media';
import { queryKey } from 'constants/queryKey';
import { Asset } from 'types/Attachments';
import { AssetFilters } from 'app/modules/mediaLibraryPage/types/AssetFilters';
import { MediaLibraryPageConfig } from 'app/config/mediaLibraryPage';

interface AssetsListPage {
  data: Asset[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

interface UseAlbumAssetsParams {
  albumId: string | undefined;
  filters: AssetFilters;
  currentUserId: number;
}

export default function useAlbumAssets(
  params: UseAlbumAssetsParams,
): UseInfiniteQueryResult<AssetsListPage> {
  const { albumId, filters, currentUserId } = params;
  return useInfiniteQuery(
    queryKey.mediaLibraryPage.assets(albumId ?? '', filters),
    ({ pageParam = 1 }) =>
      MediaApi.listAssets({
        albumId: albumId as string,
        type: filters.type,
        search: filters.search,
        createdBy: filters.uploadedBy === 'me' ? currentUserId : undefined,
        sortBy: filters.sort.by,
        sortDirection: filters.sort.direction,
        page: pageParam,
        limit: MediaLibraryPageConfig.PAGE_SIZE,
      }) as Promise<AssetsListPage>,
    {
      enabled: typeof albumId === 'string' && albumId.length > 0,
      getNextPageParam: (lastPage) =>
        lastPage.meta.current_page < lastPage.meta.last_page
          ? lastPage.meta.current_page + 1
          : undefined,
    },
  );
}
